import { Button } from '@progress/kendo-react-buttons'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { Card, CardBody, CardHeader, CardTitle, GridLayout, GridLayoutItem, StackLayout } from '@progress/kendo-react-layout'
import { Input, Checkbox } from '@progress/kendo-react-inputs'

import './CodeName.css'

const codeKbn = ['', '費目', '建物用途']

export default function CodeNameInput() {
  return (
    <div>
      <Card style={{ margin: 20 }}>
        <CardHeader>
          <CardTitle>コード区分説明</CardTitle>
        </CardHeader>
        <CardBody>
          <div>建築する上での役割・担当</div>
        </CardBody>
      </Card>

      <Card style={{ margin: 20 }}>
        <CardHeader>
          <CardTitle>コード情報</CardTitle>
        </CardHeader>
        <CardBody>
          <GridLayout>
            <GridLayoutItem col={1} row={1} className="grid-layout-item-title">
              コード区分
            </GridLayoutItem>
            <GridLayoutItem col={1} row={2}>
              <DropDownList data={codeKbn} defaultValue={'費目'} />
            </GridLayoutItem>

            <GridLayoutItem col={2} row={1} className="grid-layout-item-title">
              コード
            </GridLayoutItem>
            <GridLayoutItem col={2} row={2}>
              <Input value={'H1'} disabled />
            </GridLayoutItem>

            <GridLayoutItem col={3} row={1} className="grid-layout-item-title">
              名称
            </GridLayoutItem>
            <GridLayoutItem col={3} row={2}>
              <Input value={'型枠工'} />
            </GridLayoutItem>

            <GridLayoutItem col={4} row={1} className="grid-layout-item-title">
              略称
            </GridLayoutItem>
            <GridLayoutItem col={4} row={2}>
              <Input value={'型枠工'} />
            </GridLayoutItem>

            <GridLayoutItem col={5} row={1} className="grid-layout-item-title">
              表示順
            </GridLayoutItem>
            <GridLayoutItem col={5} row={2}>
              <Input value={'1'} />
            </GridLayoutItem>

            <GridLayoutItem col={6} row={1} className="grid-layout-item-title">
              無効フラグ
            </GridLayoutItem>
            <GridLayoutItem col={6} row={2} className="grid-layout-item-check" style={{ marginTop: '5px' }}>
              <Checkbox />
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
      </Card>

      <Card style={{ margin: 20 }}>
        <CardHeader>
          <CardTitle>区分値</CardTitle>
        </CardHeader>
        <CardBody>
          <GridLayout>
            <GridLayoutItem col={1} row={1} className="grid-layout-item-title">
              テキスト１
            </GridLayoutItem>
            <GridLayoutItem col={1} row={2} className="grid-layout-item">
              <Input defaultValue={'型枠工'} />
            </GridLayoutItem>
            <GridLayoutItem col={1} row={3} className="grid-layout-item-title">
              数値１
            </GridLayoutItem>
            <GridLayoutItem col={1} row={4}>
              <Input />
            </GridLayoutItem>

            <GridLayoutItem col={2} row={1} className="grid-layout-item-title">
              テキスト２
            </GridLayoutItem>
            <GridLayoutItem col={2} row={2} className="grid-layout-item">
              <Input />
            </GridLayoutItem>
            <GridLayoutItem col={2} row={3} className="grid-layout-item-title">
              数値２
            </GridLayoutItem>
            <GridLayoutItem col={2} row={4}>
              <Input />
            </GridLayoutItem>

            <GridLayoutItem col={3} row={1} className="grid-layout-item-title">
              テキスト３
            </GridLayoutItem>
            <GridLayoutItem col={3} row={2} className="grid-layout-item">
              <Input />
            </GridLayoutItem>
            <GridLayoutItem col={3} row={3} className="grid-layout-item-title">
              数値３
            </GridLayoutItem>
            <GridLayoutItem col={3} row={4}>
              <Input />
            </GridLayoutItem>

            <GridLayoutItem col={4} row={1} className="grid-layout-item-title">
              テキスト４
            </GridLayoutItem>
            <GridLayoutItem col={4} row={2} className="grid-layout-item">
              <Input />
            </GridLayoutItem>
            <GridLayoutItem col={4} row={3} className="grid-layout-item-title">
              数値４
            </GridLayoutItem>
            <GridLayoutItem col={4} row={4}>
              <Input />
            </GridLayoutItem>

            <GridLayoutItem col={5} row={1} className="grid-layout-item-title">
              テキスト５
            </GridLayoutItem>
            <GridLayoutItem col={5} row={2} className="grid-layout-item">
              <Input />
            </GridLayoutItem>
            <GridLayoutItem col={5} row={3} className="grid-layout-item-title">
              数値５
            </GridLayoutItem>
            <GridLayoutItem col={5} row={4}>
              <Input />
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
      </Card>

      <StackLayout gap={5} align={{ horizontal: 'end' }}>
        <Button themeColor="primary" className="pcy-button-long">
          登録/修正
        </Button>
        <Button className="pcy-button-long">戻る</Button>
      </StackLayout>
    </div>
  )
}
